import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { RadioGroup } from "@freightsimple/ui-core/Controls/RadioGroup";
import type { NmfcSubItemChoice } from "@freightsimple/generated-dashboard-openapi-client/models/NmfcSubItemChoice";
import { useState } from "react";

interface SelectNmfcSubItemDialogProps extends DialogBaseProps {
  subItems: Array<NmfcSubItemChoice>;
  onConfirm: (subItem: string) => void;
}

export function LineItemsSelectNmfcSubItemDialog(
  props: SelectNmfcSubItemDialogProps,
) {
  // "" means nothing picked yet — RadioGroup is a controlled string, and no
  // sub-item can have an empty code, so it doubles as the pristine state.
  const [selectedSubItem, setSelectedSubItem] = useState("");

  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Select the applicable NMFC Subitem"
      description="Please select the description most relevant to your shipment. Any required calculations will be handled automatically."
      okText="Use This Subitem"
      cancelText="Cancel"
      okDisabledIfPristine
      okDisabledMessage="Select an NMFC sub-item to confirm"
      onOk={() => {
        props.onConfirm(selectedSubItem);
      }}
    >
      <ControlPresentationProvider presentation="underlined">
        <RadioGroup
          vertical
          value={selectedSubItem}
          onChange={setSelectedSubItem}
          options={props.subItems.map((subItem) => ({
            value: subItem.nmfcCodeWithSubItem,
            label: subItem.nmfcCodeWithSubItem,
            description: subItem.description,
          }))}
        />
      </ControlPresentationProvider>
    </Dialog>
  );
}
